var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('models/breeze',["require", "exports", "models/controller", "services/trace", "models/account"], function (require, exports, Controller, Trace, Account) {
    "use strict";
    var BreezeManager = (function () {
        function BreezeManager(servicePath) {
            breeze.NamingConvention.camelCase.setAsDefault();
            this._dataService = new breeze.DataService({
                serviceName: servicePath,
                hasServerMetadata: false
            });
            this._entityManager = new breeze.EntityManager({ dataService: this._dataService });
            this._metadataStore = this._entityManager.metadataStore;
        }
        BreezeManager.prototype.getMetadataStore = function () {
            return this._metadataStore;
        };
        BreezeManager.prototype.executeQuery = function (query, fromServer) {
            if (fromServer === void 0) { fromServer = true; }
            var strategy = (fromServer) ? breeze.FetchStrategy.FromServer : breeze.FetchStrategy.FromLocalCache;
            return this._entityManager.executeQuery(query.using(strategy));
        };
        return BreezeManager;
    }());
    exports.BreezeManager = BreezeManager;
    var BreezeRepository = (function () {
        function BreezeRepository(servicePath) {
            this._servicePath = servicePath;
            this._manager = new BreezeManager(servicePath);
        }
        BreezeRepository.prototype.onMetadataRequested = function (store) {
        };
        BreezeRepository.prototype.query = function (actionName, parameters) {
            if (actionName == null)
                actionName = BreezeRepository.DefaultActionName;
            var query = breeze.EntityQuery
                .from(actionName);
            //.inlineCount(true);
            if (parameters != null) {
                query = query.withParameters(parameters);
            }
            return query;
        };
        BreezeRepository.prototype.all = function () {
            var query = breeze.EntityQuery
                .from(BreezeRepository.DefaultActionName);
            //.inlineCount(true);
            return this.execute(query);
        };
        BreezeRepository.prototype.orderedBy = function (propertyPath) {
            var query = breeze.EntityQuery
                .from(BreezeRepository.DefaultActionName)
                .orderBy(propertyPath);
            //.inlineCount(true);
            return this.execute(query);
        };
        BreezeRepository.prototype.execute = function (query, fromServer) {
            if (fromServer === void 0) { fromServer = true; }
            return this._manager.executeQuery(query, fromServer);
        };
        BreezeRepository.DefaultActionName = "all";
        return BreezeRepository;
    }());
    exports.BreezeRepository = BreezeRepository;
    var BreezeColumnFilter = (function (_super) {
        __extends(BreezeColumnFilter, _super);
        // #region ctor
        function BreezeColumnFilter(column, operator, needle, list) {
            _super.call(this, column, operator, needle, list);
            this.dataType = typeof (needle);
        }
        // #endregion
        // #region static construction
        BreezeColumnFilter.equals = function (column, needle) {
            return new BreezeColumnFilter(column, "eq", needle, null);
        };
        BreezeColumnFilter.contains = function (column, needle) {
            needle = needle.replace("'", "''''");
            return new BreezeColumnFilter(column, "substringof", needle, null);
        };
        BreezeColumnFilter.newerThan = function (column, date) {
            var filter = new BreezeColumnFilter(column, "gt", date, null);
            filter.dataType = "moment";
            return filter;
        };
        BreezeColumnFilter.olderThan = function (column, date) {
            var filter = new BreezeColumnFilter(column, "lt", date, null);
            filter.dataType = "moment";
            return filter;
        };
        BreezeColumnFilter.greaterThan = function (column, needle) {
            var filter = new BreezeColumnFilter(column, "gt", needle, null);
            return filter;
        };
        BreezeColumnFilter.lowerThan = function (column, needle) {
            var filter = new BreezeColumnFilter(column, "lt", needle, null);
            return filter;
        };
        BreezeColumnFilter.isNull = function (column) {
            var filter = new BreezeColumnFilter(column, "eq", "null", null);
            filter.dataType = "string";
            return filter;
        };
        // #endregion
        BreezeColumnFilter.prototype.setCustomDataType = function (dataType) {
            this.dataType = dataType;
            return this;
        };
        BreezeColumnFilter.prototype.build = function () {
            var filter;
            var needle = this.encapsulateNeedle(this.needle);
            switch (this.operator) {
                case "substringof":
                    filter = this.operator + "(" + needle + ", tolower(" + this.column + "))";
                    break;
                case "eq":
                    filter = this.column + ' ' + this.operator + ' ' + this.encapsulateNeedle(this.needle, false);
                    break;
                default:
                    filter = this.column + ' ' + this.operator + ' ' + needle;
                    break;
            }
            if (this.list != null && this.list != "") {
                filter = this.list + "/any(x: x/" + filter + ")";
            }
            return filter;
        };
        BreezeColumnFilter.prototype.encapsulateNeedle = function (needle, lowerCase) {
            if (lowerCase === void 0) { lowerCase = true; }
            if (this.dataType === "number" || this.dataType === "boolean") {
                return needle;
            }
            if (this.dataType === "moment") {
                var date = needle;
                return "datetime'" + date.format() + "'";
            }
            if (this.dataType === "guid") {
                return "guid'" + needle + "'";
            }
            return lowerCase
                ? '\'' + needle.toLowerCase() + '\''
                : '\'' + needle + '\'';
        };
        return BreezeColumnFilter;
    }(Controller.ColumnFilter));
    exports.BreezeColumnFilter = BreezeColumnFilter;
    var BreezeDateRangeFilter = (function (_super) {
        __extends(BreezeDateRangeFilter, _super);
        function BreezeDateRangeFilter(key, start, end) {
            _super.call(this, key, null, "", null);
            this._start = start;
            this._end = end;
            this.dataType = "moment";
        }
        BreezeDateRangeFilter.prototype.isValid = function () {
            return true;
        };
        BreezeDateRangeFilter.prototype.build = function () {
            // 1. TO >= InputFrom and TO <= InputTo
            // 2. FROM >= InputFrom and FROM <= InputTo
            // 3. FROM <= InputFrom and TO >= InputTo
            var columnFrom = this.column + "From";
            var columnTo = this.column + "To";
            var start = this.encapsulateNeedle(this._start.startOf('day'));
            var end = this.encapsulateNeedle(this._end.endOf('day'));
            var func = columnTo + " ge " + start + " and " + columnTo + " le " + end;
            func = func + " or " + columnFrom + " ge " + start + " and " + columnFrom + " le " + end;
            func = func + " or " + columnFrom + " le " + start + " and " + columnTo + " ge " + end;
            return func;
        };
        return BreezeDateRangeFilter;
    }(BreezeColumnFilter));
    exports.BreezeDateRangeFilter = BreezeDateRangeFilter;
    var BreezeOrFilter = (function (_super) {
        __extends(BreezeOrFilter, _super);
        function BreezeOrFilter(key) {
            var filters = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                filters[_i - 1] = arguments[_i];
            }
            _super.call(this, key, null, "", null);
            this._filters = [];
            this._filters = filters;
            this.dataType = "";
        }
        BreezeOrFilter.prototype.setFilters = function (filters) {
            this._filters = filters;
        };
        BreezeOrFilter.prototype.getFilters = function () {
            return this._filters;
        };
        BreezeOrFilter.prototype.isValid = function () {
            return true;
        };
        BreezeOrFilter.prototype.build = function () {
            var query = "";
            this._filters.forEach(function (s) {
                query = query + ((query != "") ? " or " + s.build() : s.build());
            });
            return "(" + query + ")";
        };
        return BreezeOrFilter;
    }(BreezeColumnFilter));
    exports.BreezeOrFilter = BreezeOrFilter;
    var BreezeColumnSort = (function (_super) {
        __extends(BreezeColumnSort, _super);
        function BreezeColumnSort(column, operator) {
            _super.call(this, column, operator);
        }
        BreezeColumnSort.prototype.build = function () {
            return this.column + ' ' + this.operator;
        };
        return BreezeColumnSort;
    }(Controller.ColumnSort));
    exports.BreezeColumnSort = BreezeColumnSort;
    var BreezeDataController = (function (_super) {
        __extends(BreezeDataController, _super);
        // #region ctor
        function BreezeDataController(dataSource, parameters, usePaging) {
            if (usePaging === void 0) { usePaging = true; }
            _super.call(this);
            this._usePaging = true;
            this.pageSize(Account.Session.rowCount);
            this._parameters = parameters;
            this._actionName = BreezeRepository.DefaultActionName;
            this._dataSource = dataSource;
            this._usePaging = usePaging;
            this._map = function (data) { return data; };
        }
        // #endregion
        // #region overrides
        BreezeDataController.prototype.onLoadAsync = function () {
            var that = this;
            that.clearData();
            // create query
            var query = that._dataSource.query(that._actionName, that.parameters);
            if (that._usePaging) {
                query = query.skip(+((that.currentPage() - 1) * that.pageSize())).take(that.pageSize());
            }
            // configure
            if (that.sortDefinitions != null && that.sortDefinitions.length > 0) {
                that.sortDefinitions.forEach(function (s) {
                    if (s != null && s.column != null) {
                        query = query.orderBy(s.build());
                    }
                });
            }
            if (that.filterDefinitions != null && that.filterDefinitions.length > 0) {
                that.filterDefinitions.forEach(function (f) {
                    if (f != null && f.isValid()) {
                        var predicate = f.build();
                        query = query.where(predicate);
                    }
                });
            }
            // execute
            return that._dataSource.execute(query, true)
                .then(function (response) {
                //that.pageCount(Math.ceil((response.inlineCount || 1) / that.pageSize()));
                //that.itemsCount(response.inlineCount);
                that.result(that._map(response.results));
            })
                .fail(function (error) {
                Trace.traceError(error, null, "controller", true);
            });
        };
        Object.defineProperty(BreezeDataController.prototype, "parameters", {
            // #endregion
            // #region properties
            get: function () {
                return this._parameters;
            },
            set: function (value) {
                this._parameters = value;
            },
            enumerable: true,
            configurable: true
        });
        // #endregion
        // #region configuration
        BreezeDataController.prototype.configure = function (map) {
            this._map = map;
            return this;
        };
        // #endregion
        // #region overriding
        BreezeDataController.prototype.override = function (actionName, parameters) {
            if (typeof actionName != "undefined") {
                this._actionName = actionName;
            }
            if (parameters != null) {
                this.parameters = parameters;
            }
            return this;
        };
        // #endregion
        // #region build items
        BreezeDataController.prototype.buildFilter = function (column, operator, needle, list) {
            return new BreezeColumnFilter(column, operator, needle, list);
        };
        BreezeDataController.prototype.buildSort = function (column, operator) {
            return new BreezeColumnSort(column, operator);
        };
        // #endregion
        BreezeDataController.prototype.clearData = function () {
            this.result.removeAll();
            this.itemsCount(0);
        };
        return BreezeDataController;
    }(Controller.PageableDataController));
    exports.BreezeDataController = BreezeDataController;
});

